module.exports = __webpack_public_path__ + "static/media/top_left.png.7c86e60e.png";